import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Body from "./Components/BodyComp/body";
import AboutUs from "./Components/AboutComp/aboutus";
import ContactUs from "./Components/ContactComp/contactus";
import Gallery from "./Components/GalleryComp/gallery";
import Navbar from "./Components/NavComp/navbar";
import Footer from "./Components/FooterComp/footer";
import GetInvolvedToday from "./Components/GetInvolvedComp/get-involved-today";
import ScrollToTop from "./ScrollComp/ScrollToTop";



function App() {
  return (
    <Router>
      <Navbar />
      <div className="App">
        <Routes>
          <Route path="/" element={<Body />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/get-involved-today" element={<GetInvolvedToday />} />
        </Routes>
      </div>
      <Footer />
      <ScrollToTop />
    </Router>
  );
}

export default App;
